"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { FiMinus, FiPlus, FiX } from "react-icons/fi";
import Button from "@/components/ui/button";
import { DurationInput } from "@/components/ui/duration-input";
import { Label } from "@/components/ui/label";
const MIN_PASSES = 2;
const MAX_PASSES = 50;
interface CycleCreationConfigProps {
  stepCount: number;
  onConfirm: (passCount: number, gapMinutes: number) => void;
  onCancel: () => void;
}
export function CycleCreationConfig(t0) {
  const $ = _c(42);
  const {
    stepCount,
    onConfirm,
    onCancel
  } = t0;
  const [passCount, setPassCount] = useState(2);
  const [gapMinutes, setGapMinutes] = useState(10080);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = delta => {
      setPassCount(prev => Math.max(MIN_PASSES, Math.min(MAX_PASSES, prev + delta)));
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handlePassCountChange = t1;
  const stepsLabel = stepCount === 1 ? "1 step" : `${stepCount} steps`;
  const passesLabel = passCount === 1 ? "1 pass" : `${passCount} passes`;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className="text-body-strong text-foreground">Configure Cycle</p>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FiX size={16} />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== onCancel) {
    t4 = <div className="flex items-center justify-between">{t2}<button type="button" onClick={onCancel} className="text-foreground-secondary hover:text-foreground transition-colors">{t3}</button></div>;
    $[3] = onCancel;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Label className="text-caption text-foreground-secondary">Number of passes</Label>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => handlePassCountChange(-1);
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = passCount <= MIN_PASSES;
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <FiMinus size={14} />;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== t7) {
    t9 = <Button variant="ghost" size="sm" onClick={t6} disabled={t7} icon={t8} />;
    $[8] = t7;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== passCount) {
    t10 = <span className="w-8 text-center text-body-strong text-foreground">{passCount}</span>;
    $[10] = passCount;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => handlePassCountChange(1);
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  const t12 = passCount >= MAX_PASSES;
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <FiPlus size={14} />;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] !== t12) {
    t14 = <Button variant="ghost" size="sm" onClick={t11} disabled={t12} icon={t13} />;
    $[14] = t12;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  let t15;
  if ($[16] !== t10 || $[17] !== t14 || $[18] !== t9) {
    t15 = <div className="space-y-1">{t5}<div className="flex items-center gap-2">{t9}{t10}{t14}</div></div>;
    $[16] = t10;
    $[17] = t14;
    $[18] = t9;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Label className="text-caption text-foreground-secondary">Gap between passes</Label>;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  let t17;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = val => setGapMinutes(val ?? 0);
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  let t18;
  if ($[22] !== gapMinutes) {
    t18 = <div className="space-y-1">{t16}<DurationInput value={gapMinutes} onChange={t17} min={0} defaultUnit="minutes" placeholder="0" /></div>;
    $[22] = gapMinutes;
    $[23] = t18;
  } else {
    t18 = $[23];
  }
  let t19;
  if ($[24] !== passesLabel || $[25] !== stepsLabel) {
    t19 = <p className="text-caption text-foreground-secondary bg-background-secondary rounded-md px-3 py-2">{stepsLabel} repeated over {passesLabel}</p>;
    $[24] = passesLabel;
    $[25] = stepsLabel;
    $[26] = t19;
  } else {
    t19 = $[26];
  }
  let t20;
  if ($[27] !== onCancel) {
    t20 = <Button variant="secondary" size="sm" onClick={onCancel}>Cancel</Button>;
    $[27] = onCancel;
    $[28] = t20;
  } else {
    t20 = $[28];
  }
  let t21;
  if ($[29] !== gapMinutes || $[30] !== onConfirm || $[31] !== passCount) {
    t21 = <Button variant="primary" size="sm" onClick={() => onConfirm(passCount, gapMinutes)}>Create Cycle</Button>;
    $[29] = gapMinutes;
    $[30] = onConfirm;
    $[31] = passCount;
    $[32] = t21;
  } else {
    t21 = $[32];
  }
  let t22;
  if ($[33] !== t20 || $[34] !== t21) {
    t22 = <div className="flex items-center gap-2 pt-1">{t20}{t21}</div>;
    $[33] = t20;
    $[34] = t21;
    $[35] = t22;
  } else {
    t22 = $[35];
  }
  let t23;
  if ($[36] !== t15 || $[37] !== t18 || $[38] !== t19 || $[39] !== t22 || $[40] !== t4) {
    t23 = <div className="space-y-3">{t4}{t15}{t18}{t19}{t22}</div>;
    $[36] = t15;
    $[37] = t18;
    $[38] = t19;
    $[39] = t22;
    $[40] = t4;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  return t23;
}